module.exports = __webpack_public_path__ + "img/empty.931ad7e5.png";